import {makeStyles} from "@mui/styles";

const useStyles = makeStyles(theme => ({
    title: {
        textAlign: isMobile => isMobile ? 'center' : 'left',
        fontWeight: 'bold',
    },
}));

export default useStyles;